import styled from "styled-components";


export const CallLogsContainer = styled.div`
  min-width: 25vw;
  height: 85vh;
  border: 1px solid red;

  @media (max-width: 768px) {
    width: 100vw;
    height: 84vh;
  }
`;
// export const NoChatContainer = styled.div``
// export const NoChatContainer = styled.div``
// export const NoChatContainer = styled.div``
